import React from "react";
import "./Skills.css";
import {SectionHeading2} from "../";
import {OutlinedLogoWhite} from "../../assets/images";
import {SkillsData} from "../../constants/Skills";

import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";
import "swiper/css";

// Duplicate slides for marquee
const marqueeSlides = [...SkillsData, ...SkillsData];

const Skills = () => {
  return (
    <section className="section skills-section">
      <div className="container skills-container">
        <SectionHeading2
          title1="My Skills"
          title2=" & Techs"
          description="I build fast, scalable, and user-focused web applications using modern frameworks, backend services, and deployment tools — blending technical skill with design precision."
          image={OutlinedLogoWhite}
        />

        <div className="skills-swiper-wrapper">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={6}
            loop={true}
            speed={2000}
            freeMode={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            allowTouchMove={true}
            grabCursor={true}
            breakpoints={{
              320: {slidesPerView: 2},
              640: {slidesPerView: 3},
              768: {slidesPerView: 4},
              1024: {slidesPerView: 5},
              1280: {slidesPerView: 6},
            }}
          >
            {marqueeSlides.map((skills, index) => (
              <SwiperSlide key={index} className="skills-slide">
                <div className="skills-item">
                  <div className="skills-icon">
                    <img src={skills.icon} alt={skills.icon} />
                  </div>
                  <h2 className="counter-title">
                    <span>{skills.proficiency}</span>%
                  </h2>
                  <span className="skill-name">{skills.name}</span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          <div className="skills-gradient-left"></div>
          <div className="skills-gradient-right"></div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
